import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { SnackbarService } from '../../_service/message-service';
import { Subscription } from 'rxjs';
import { LoaderService } from 'src/app/loader.service';
import { UserService } from 'src/app/_services';
import { Role } from 'src/app/util/enums/role.enum';
import { TableBtn, TableColumn } from 'src/app/shared/interfaces';
import { TranslateService } from '@ngx-translate/core';
import { ExportCSVService } from 'src/app/_services/export-csv.service';
import { GeneralDialogComponent } from 'src/app/shared/components/general-dialog/general-dialog.component';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { Permission } from 'src/app/util/enums/permission.enum';
import { AuthenticationService } from 'src/app/_services';
import { RouteConstants } from 'src/app/util/route.constants';
import { BreadcrumbService } from '../breadcrumb/breadcrumb.service';

export interface ticketData {
  id: string;
  cpoEmail: string;
  queryType: string;
  description: string;
  date: string;
  time: string;
}
@Component({
  selector: 'telio-tickets',
  templateUrl: './tickets.component.html',
  styleUrls: ['./tickets.component.scss']
})
export class TicketsComponent implements OnInit, OnDestroy {
  columns: TableColumn[];
  buttons: TableBtn[];
  actionHeader: string = '';
  filterPlaceholder: string = '';
  actionFeatureLabel: string = '';
  enableNewRequest = false;
  initialData: any;
  subscriptions = new Subscription();
  tickets: ticketData[]
  data = [];
  userDetails: any = {};
  vendormailid: any;

  pageList = {
    currentPage: 0,
    pageSize: 10
  };
  currentPage = 0;
  totalDataCount = 0;
  sortColumn = '';
  sortDirection = 'asc';

  constructor(private userservice: UserService,
    private router: Router,
    private toastr: SnackbarService,
    public translate: TranslateService,
    readonly exportCSVService: ExportCSVService,
    private userInfoService: UserInfoService,
    public loaderService: LoaderService,
    readonly dialog: MatDialog,
    private authenticationService:AuthenticationService,
    readonly route: ActivatedRoute,readonly breadcrumbService: BreadcrumbService) {
    this.userDetails = this.userInfoService.userDetails;
    this.vendormailid = this.userDetails.email;
    this.rerender(this.pageList, '');
  }

  ngOnInit(): void {
    this.columns = [
      { columnDef: 'ticketId', header: 'serviceRequest.ticketId', cell: (element: ticketData) => `${element.id}`, sortingDisabled: false, width: '100px', isLink: this.userInfoService.filterPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.UPDATE) },
      { columnDef: 'vendorEmail', header: 'serviceRequest.cpoEmail', cell: (element: ticketData) => `${element.cpoEmail}`, sortingDisabled: false, width: '150px' },
      { columnDef: 'issuetype', header: 'serviceRequest.queryType', cell: (element: ticketData) => `${element.queryType}`, sortingDisabled: false, width: '100px' },
      { columnDef: 'description', header: 'serviceRequest.description', cell: (element: ticketData) => `${element.description}`, sortingDisabled: false, width: '100px' },
      { columnDef: 'createdDate', header: 'serviceRequest.date', cell: (element: ticketData) => `${element.date}`, sortingDisabled: false, width: '100px' },
      { columnDef: 'time', header: 'serviceRequest.time', cell: (element: ticketData) => `${element.time}`, sortingDisabled: true, width: '100px' }
    ];
    this.buttons = [
    ];
    this.filterPlaceholder = 'generalTable.filterPlaceholder';
    this.actionHeader = 'actions';
    this.actionFeatureLabel = 'serviceRequest.newRequest';
    this.enableNewRequest = this.userInfoService.filterPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.CREATE) && !this.userInfoService.isAdminGroup();
  }

  actionClick() {
    this.rerender(this.pageList);
  }

  applyFilter(filteredData: string) {
    this.rerender(this.pageList, filteredData)
  }

  actionCSV() {
    const options = {
      filename: this.translate.instant('serviceRequest.title'),
      showTitle: false,
      title: this.translate.instant('serviceRequest.title'),
      useKeysAsHeaders: true,
    }
    if(this.userInfoService.isAdminGroup()){
      this.subscriptions.add(this.userservice.getAllTickets(1, this.totalDataCount, this.sortColumn, 'asc', '').subscribe((resp: any) => {
        this.initialData = resp.data
        this.setTicketsMap(this.initialData)
        this.initialData = this.initialData.map((item:any)=>{
          delete item.comment;
          delete item.createdDate;
          return item
         })
        this.exportCSVService.exportCSV(options, this.initialData);
      }))
    } else{
      this.subscriptions.add(this.userservice.getTicketsByVendorEmail(this.vendormailid,1, this.totalDataCount, this.sortColumn, 'asc', '').subscribe((resp: any) => {
        this.initialData = resp.data
        this.setTicketsMap(this.initialData)
        this.exportCSVService.exportCSV(options, this.initialData);
      }))
    }
  }

  buttonClick(result: string[]) {
    switch (result[0]) {
      case 'delete':
        this.deleteFeature(result[1]);
        break;
      default:
        break;
    }
  }

  linkClick(event) {
    if (event.column.columnDef == "ticketId") {
      let objToSend: NavigationExtras = {
        queryParams: {
          "ticketid": event.row.id,
        },
        skipLocationChange: true
      };
      this.userInfoService.isAdminGroup() ? this.router.navigate(["/dashboard/service-request/edit", { routeID: this.route.snapshot.paramMap.get('routeID') }],objToSend) : this.router.navigate(["/dashboard/service-request/edit-vendor", { routeID: this.route.snapshot.paramMap.get('routeID') }],objToSend);
      this.breadcrumbService.emitBreadCrumbs(RouteConstants.SERVICE_REQUEST_TICKET_MESSAGE);
    }
  }

  deleteTicketbyid(deleteid: any) {
    this.userservice.deleteTicket(deleteid).subscribe((resp: any) => {
      if (!!resp) {
        this.toastr.success(resp)
        this.rerender(this.pageList)
      }
      else {
        this.toastr.error(resp)
      }
    },
      error => {
        if (error == 'OK') {
        }
      }
    )
  }

  rerender(value: any, searchFilter?: string) {
    this.userInfoService.isAdminGroup() ? this.getTicketlist(value, searchFilter) : this.getTicketsByVendor(value, this.vendormailid, searchFilter);
  }

  getTicketsByVendor(value: any, vendormailid?: any, searchFilter: string = '') {
    this.subscriptions.add(this.userservice.getTicketsByVendorEmail(vendormailid, value.currentPage + 1, value.pageSize, this.sortColumn, this.sortDirection, searchFilter).subscribe((resp: any) => {
      this.tickets = resp.data
      this.totalDataCount = resp.totalItems;
      this.setTicketsMap(this.tickets)
    }))
  }

  getTicketlist(value: any, searchFilter: string = '') {
    this.subscriptions.add(this.userservice.getAllTickets(value.currentPage + 1, value.pageSize, this.sortColumn, this.sortDirection, searchFilter).subscribe((resp: any) => {
      this.tickets = resp.data
      this.totalDataCount = resp.totalItems;
      this.setTicketsMap(this.tickets)
    }))
  }

  dateTransformCreatedDate(date: string) {
    let dateIn: Date = new Date(date);
    dateIn.setHours(dateIn.getHours() + 5);
    dateIn.setMinutes(dateIn.getMinutes() + 30);
    let dateOut = dateIn.toISOString().replace("T", " ").substring(0, 10);
    return dateOut;
  }

  actionFeature(e) {
    this.router.navigate(["/dashboard/service-request/new-request", { routeID: this.route.snapshot.paramMap.get('routeID') }])
    this.breadcrumbService.emitBreadCrumbs(RouteConstants.SERVICE_REQUEST_CREATE);
  }

  loadData(value: any) {
    let val = {
      currentPage: value.currentPage,
      pageSize: value.pageSize
    }
    this.pageList.pageSize = value.pageSize;
    this.rerender(val, '')
  }

  sortClick(event: any) {
    this.sortColumn = event.active;
    this.sortDirection = event.direction;
    this.rerender(this.pageList, '');
  }

  deleteFeature(id: any): void {
    let dialogRef = this.dialog.open(GeneralDialogComponent, {
      width: '50vw',
      height: '200px',
      data: { component: ConfirmDialogComponent, button: this.translate.instant('faq.confirmButton'), title: this.translate.instant('createStation.confiration'), otherbtn: this.translate.instant('faq.confirmNo'), message: this.translate.instant('serviceRequest.deleteTitle') }
    }).afterClosed().subscribe(res => {
      if (res && res == 'Yes') {
        this.deleteTicketbyid(id);
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions && this.subscriptions.unsubscribe();
  }

  setTicketsMap(data){
      data.map((item: any, id: number) => {
      let empty = 'NA';
      item.id = !item.id ? empty : item.id
      item.cpoEmail = !item.vendorEmail ? empty : item.vendorEmail
      item.queryType = !item.issuetype ? empty : item.issuetype
      item.description = !item.description ? empty : item.description
      // item.date = !item.createdDate ? empty : this.dateTransformCreatedDate(item.createdDate)
      item.date = !item.createdDate ? empty : this.authenticationService.convertToLocalTime(item.createdDate, this.userInfoService.userDetails.prefCountry).split(' ')[0];
      // item.time = !item.createdDate ? empty : this.authenticationService.convert24HrTo12Hr(item.createdDate).slice(11,19)
      item.time = !item.createdDate ? empty : this.authenticationService.convert24HrTo12Hr(this.authenticationService.convertToLocalTime(item.createdDate, this.userInfoService.userDetails.prefCountry)).slice(11, 19);
    });
  }
}
